import React from 'react';
import { Section } from '@atlaskit/menu';
import { fg } from '@atlassian/jira-feature-gating';
import { useHasToolSections } from '@atlassian/jira-software-connect-toolbar/src/controllers/index.tsx';
import { BoardConnectMenuItems } from '@atlassian/jira-software-connect-toolbar/src/ui/board-connect-menu-items/index.tsx';
import { backlogConnectAppLocations } from '../../../constants.tsx';
import Operations from '../../../extension/index.tsx';

type BoardConnectItemsProps = {
	projectKey: string;
	boardId: string;
	isCompanyManaged?: boolean;
	hasOperations?: boolean;
};

export const BoardConnectItems = ({
	projectKey,
	boardId,
	isCompanyManaged,
	hasOperations,
}: BoardConnectItemsProps) => {
	const hasToolSections = useHasToolSections({
		boardId,
		projectKey,
		mode: 'plan',
		itemLocations: backlogConnectAppLocations,
	});

	return (
		(hasToolSections || hasOperations) && (
			<Section hasSeparator>
				{isCompanyManaged && (
					<>
						<BoardConnectMenuItems
							boardId={boardId}
							projectKey={projectKey}
							location="board-tools-1"
							mode="plan"
							isTabNavigation={fg('jsm_views_connect_apps_bugfix')}
						/>
						<BoardConnectMenuItems
							boardId={boardId}
							projectKey={projectKey}
							location="view-actions-print"
							mode="plan"
							isTabNavigation={fg('jsm_views_connect_apps_bugfix')}
						/>
						<BoardConnectMenuItems
							boardId={boardId}
							projectKey={projectKey}
							mode="plan"
							isTabNavigation={fg('jsm_views_connect_apps_bugfix')}
						/>
					</>
				)}
				<Operations isTabNavigation={fg('jsm_views_connect_apps_bugfix')} />
			</Section>
		)
	);
};
